<template lang="pug">
.capital-market-publications.module-layout
	.capital-market-publications__loader(v-if="formState == FORM_STATES.LOADING")
		VueSpinner
	TechnicalError(v-if="formState == FORM_STATES.TECHNICAL_ERROR")
	template(v-if="formState == FORM_STATES.FORM")
		VueAccordion(:value="defaultActiveMonth")
			VueAccordionItem(v-for="group in monthGroups", :key="group.monthKey", :name="group.monthKey")
				span(slot="title") {{ group.label }}
				ul.sf-list
					li.sf-listitem(v-for="(publication, pIdx) in group.publications", :key="pIdx")
						template(v-if="publication.files.length === 1")
							| {{ formatDay(publication.publishDate) }} -
							| &nbsp;
							a.sf-link(:href="publication.files[0].path", target="_blank") {{ publication.files[0].title }}
						template(v-else)
							| {{ formatDay(publication.publishDate) }}
							ul.sf-list
								li.sf-listitem(v-for="(file, fIdx) in publication.files", :key="fIdx")
									a.sf-link(:href="file.path", target="_blank") {{ file.title }}
</template>

<script>
import moment from 'moment';
import { VueAccordion, VueAccordionItem } from '@ui-common/vue-accordion';
import VueSpinner from '@ui-common/vue-spinner';
import TechnicalError from './capital-market-publications-technical-error/capital-market-publications-technical-error.vue';
import capitalMarketPublicationsApi from '../../api/capital-market-publications-api';
import { FORM_STATES } from './constants/constants';

export default {
	components: {
		VueAccordion,
		VueAccordionItem,
		VueSpinner,
		TechnicalError
	},
	props: {
		year: {
			type: Number,
			required: true
		}
	},
	data: () => ({
		formState: FORM_STATES.LOADING,
		publications: []
	}),
	computed: {
		FORM_STATES: () => FORM_STATES,
		monthGroups() {
			const groups = new Map();
			this.publications.forEach((p) => {
				const key = moment(p.publishDate).format('YYYY-MM');
				if (!groups.has(key)) {
					groups.set(key, {
						monthKey: key,
						label: moment(p.publishDate).format('YYYY MMMM'),
						publications: []
					});
				}
				groups.get(key).publications.push(p);
			});
			return Array.from(groups.values()).sort((a, b) => b.monthKey.localeCompare(a.monthKey));
		},
		defaultActiveMonth() {
			return this.monthGroups.length ? [this.monthGroups[0].monthKey] : [];
		}
	},
	methods: {
		formatDay(date) {
			return moment(date).format('D MMMM');
		},
		async loadPublications() {
			try {
				this.formState = FORM_STATES.LOADING;
				const { data } = await capitalMarketPublicationsApi.getPublications(this.year);
				this.publications = data.publications || [];
				this.formState = FORM_STATES.FORM;
			} catch {
				this.formState = FORM_STATES.TECHNICAL_ERROR;
			}
		}
	},
	created() {
		this.loadPublications();
	}
};
</script>

<style lang="scss" scoped>
@import '@ui-common/sf-style-utils/lib/helpers/_queries.scss';

.capital-market-publications {
	margin-bottom: 8px;

	@include media('>=tablet') {
		margin-bottom: 16px;
	}
}

.capital-market-publications__loader {
	min-height: 120px;
	position: relative;
}

.capital-market-publications .el-collapse {
	@include media('<=tablet') {
		margin-left: -16px;
		margin-right: -16px;
	}
}
</style>
